import { Platform } from "react-native";
import WebImageUploader from "./WebImageUploader.web";
import NativeImageUploader from "./NativeImageUploader.native";

export default Platform.OS === "web" ? WebImageUploader : NativeImageUploader;
